import React, { Suspense, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { fetchDistributorTransactionProgress } from '../../../../services/Http/DistributorApi';

const ReactApexChart = React.lazy(() => import('react-apexcharts'));

const DistributorTransactionsProgress = ({ period }) => {
    const { t } = useTranslation();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            try {
                const response = await fetchDistributorTransactionProgress({ period });
                setData(response);
            } catch (error) {
                toast.error(t('DistributorTransactions.errors.loadProgress'));
            } finally {
                setLoading(false);
            }
        };

        load();
    }, [period, t]);

    if (loading || !data) {
        return <Placeholder>{t('common.loading')}</Placeholder>;
    }

    const createSeries = (metric) => ({
        current: data.totals.current_period_totals.map((row) => row[metric] || 0),
        previous: data.totals.previous_period_totals.map((row) => row[metric] || 0),
        categories: data.totals.current_period_totals.map((row) => row.name),
    });

    const outboundSeries = createSeries('sell_through_value');

    return (
        <div>
            <ProgressSection>
                <h4>{t('DistributorTransactions.progress.outbound')}</h4>
                <Suspense fallback={<Placeholder>…</Placeholder>}>
                    <ReactApexChart
                        type="bar"
                        height={360}
                        options={{
                            chart: { stacked: false },
                            xaxis: { categories: outboundSeries.categories },
                        }}
                        series={[
                            { name: t('DistributorTransactions.progress.current'), data: outboundSeries.current },
                            { name: t('DistributorTransactions.progress.previous'), data: outboundSeries.previous },
                        ]}
                    />
                </Suspense>
            </ProgressSection>
        </div>
    );
};

export default DistributorTransactionsProgress;

const ProgressSection = styled.div`
    border: 1px solid rgba(130, 22, 146, 0.15);
    border-radius: 12px;
    padding: 1.25rem;
`;

const Placeholder = styled.div`
    text-align: center;
    padding: 2.5rem;
`;
